import React from 'react';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
import type {
  OffsetModifier,
  PrimaryPlacement,
  ReferenceChildrenProps,
  SecondaryPlacement,
} from '@wix/da-ds/pkg/popper/types';

export interface Props {
  placement?: PrimaryPlacement;
  secondaryPlacement?: SecondaryPlacement;
  arrowClassName?: string;
  contentClassName?: string;
  referenceClassName?: string;
  children?: React.ReactNode;
  tooltipOffset?: OffsetModifier;
  onClose?: () => void;
  onReferenceClick?: (e: React.MouseEvent) => void;
  renderPopover?: (props: { closeTooltip?: () => void }) => React.ReactNode;
  /**
   * ONLY USE THIS IF YOU KNOW WHAT YOU ARE DOING
   * By default, children passed to this component will be the reference element for the popper,
   * or alternatively you can pass a renderReference prop. This is helpful if you need to make the
   * reference element be some inner node on the entire structure of the tooltip.
   */
  renderReference?: (props: ReferenceChildrenProps) => React.ReactNode;
}

const PopoverPopover: React.FC<Props> = ({
  contentClassName,
  referenceClassName,
  children,
  tooltipOffset = [0, 8],
  placement,
  secondaryPlacement,
  onClose,
  onReferenceClick,
  renderPopover,
  renderReference,
}) => {
  return (
    <PositionOnlyPopperPopover
      className={referenceClassName}
      placement={placement}
      secondaryPlacement={secondaryPlacement}
      isVisible
      onClickOutside={onClose}
      offsetModifier={tooltipOffset}
      contentClassName={contentClassName}
      onReferenceClick={onReferenceClick}
      popoverContent={() =>
        renderPopover &&
        renderPopover({
          closeTooltip: onClose,
        })
      }
      renderReference={renderReference}
    >
      {children}
    </PositionOnlyPopperPopover>
  );
};
PopoverPopover.displayName = 'PopoverPopover';

export default PopoverPopover;
